import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
export const useUnregisterMobileNotification = ()=>{
    const { api } = useStoreActions();
    const { mutate } = useMutationState({
        mutationFn: (param)=>{
            let { token, platform, authToken } = param;
            return api.mobileNotification.unregister({
                token,
                platform
            }, authToken);
        }
    });
    return {
        unregisterMobileNotification: mutate
    };
};
